import React from "react";
import { Link } from "react-router-dom";

interface ServiceCardProps {
    icon: React.ReactNode;
    title: string;
    description: string;
    btnText: string;
    btnLink: string;
}

const ServiceCard = ({ service }: { service: ServiceCardProps }) => {
    return (
        <div className="service-card">
            <div className="mb-5">
                <i className="icon-wrapper mb-3">
                    {service.icon}
                </i>
                <h4 className="card-title">{service.title}</h4>
                <p className="card-text">{service.description}</p>
            </div>
            <Link to={service.btnLink} className="btn btn-primary">
                <span>{service.btnText}</span>
                <span>{service.btnText}</span>
            </Link>
        </div>
    );
}

export default ServiceCard;